/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
export const baseUrl = `/api/internal/auth`;
export const logoutUrl = `${baseUrl}/logout`;

export interface AuthAPI {
  ping(): Promise<void>;
  login(redirectUrl: string): Promise<void>;
  logout(): Promise<void>;
  expire(): Promise<void>;
}
